import jwtDecode from 'jwt-decode';
import axios from 'utils/axios';

class AuthService {
  setAxiosInterceptors = ({ onLogout }) => {
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          this.setSession(null);

          if (onLogout) {
            onLogout();
          }
        }

        return Promise.reject(error);
      }
    );
  };

  handleAuthentication() {
    const accessToken = this.getAccessToken();

    if (!accessToken) {
      return;
    }

    if (this.isValidToken(accessToken)) {
      this.setSession(accessToken);
    } else {
      this.setSession(null);
    }
  }

  loginWithEmailAndPassword = (email, password) =>
    new Promise((resolve, reject) => {
      axios
        .post('/auth/login', { email, password })
        .then((response) => {
          if (response.data.accessToken) {
            this.setSession(response.data.accessToken);
            resolve(response.data.user);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  loginInWithToken = () =>
    new Promise((resolve, reject) => {
      axios
        .get('/account/me')
        .then((response) => {
          if (response.data.id) {
            resolve(response.data);
          } else {
            reject(response.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  logout = () => {
    this.setSession(null);

    localStorage.removeItem('sanctum_token');
  };

  setSession = (accessToken) => {
    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      try {
        const decoded = jwtDecode(accessToken);
        const sanctumToken = decoded.sanctum_token;
        if (!sanctumToken) {
          this.logout();
          window.location.href = '/login';
        } else {
          localStorage.setItem('sanctum_token', sanctumToken);
        }
      } catch (e) {
        this.logout();
        window.location.href = '/login';
      }
    } else {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('sanctum_token');
      delete axios.defaults.headers.common.Authorization;
    }
  };

  getAccessToken = () => localStorage.getItem('accessToken');

  getSanctumToken = () => localStorage.getItem('sanctum_token');

  isValidToken = (accessToken) => {
    if (!accessToken) {
      return false;
    }

    const decoded = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  };

  isAuthenticated = () => !!this.getAccessToken() && !!this.getSanctumToken();
}

const authService = new AuthService();

export default authService;
